/* eslint-disable */
export const baseUrl = import.meta.env.VITE_BACKEND_DOMAIN;
export const federation = import.meta.env.VITE_FEDERATION_DOMAIN;

export const BASE_API_URL = import.meta.env.VITE_BACKEND_DOMAIN;
export const FEDERATION_API_URL = import.meta.env.VITE_FEDERATION_DOMAIN;
export const NOTIFICATION_API_URL = import.meta.env.VITE_NOTIFICATION_SERVICE_DOMAIN;

export const TEST_BUILD = import.meta.env.VITE_TEST_BUILD;
export const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;
export const FIREBASE_API_KEY = import.meta.env.VITE_FIREBASE_API_KEY;
export const FIREBASE_AUTH_DOMAIN = import.meta.env.VITE_FIREBASE_AUTH_DOMAIN;
export const FIREBASE_PROJECT_ID = import.meta.env.VITE_FIREBASE_PROJECT_ID;
export const FIREBASE_STORAGE_BUCKET = import.meta.env.VITE_FIREBASE_STORAGE_BUCKET;
export const FIREBASE_MESSAGING_SENDER_ID = import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID;
export const FIREBASE_APP_ID = import.meta.env.VITE_FIREBASE_APP_ID;
export const REPORT_URL = import.meta.env.VITE_REPORT_URL;

export enum ApiRoutes {
	Bookings = 'booking',
	CarAccess = 'booking/car_access',
	Support = 'booking/support',
	Objects = 'booking_object',
	BookingRootObjects = 'booking_object/root',
	BookingObjectTypes = 'booking_object_type',
	Persons = 'person',
	PassTypes = 'pass_type',
	Passes = 'pass',
	Restrictions = 'restriction',
	Rating = 'rating',
	Service = 'service',
}

export enum AuthorizationRoutes {
	Session = 'session',
}

export const ADMIN_PERMISSION_NAME = 'phs.booking.admin';

export const POLLING_INTERVAL = {
	SECURITY_BOOKINGS: 900000,
};
